import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  serverTimestamp,
  Timestamp,
  updateDoc,
  orderBy,
  where,
} from "firebase/firestore";
import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommentBox from "../../components/commentbox/CommentBox";
import Like from "../../components/like/Like";
import BlogVoting from "../../components/voting/BlogVoting";
import FeatureBlogs from "../../components/FeatureBlogs";
import RelatedBlog from "../../components/relatedblog/RelatedBlog";
import Tags from "../../components/tags/Tags";
import UserComments from "../../components/UserComments";
import { db } from "../../firebase";
import Spinner from "../../components/spinner/Spinner";
import "./detail.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BlogCard from "../../components/blogcard/BlogCard";
import BlogImage from "../../components/BlogImage";
import { getFriendlyDateFormat } from "../../utility/index";

const Detail = ({ setActive, user }) => {
  const userId = user?.uid;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [blog, setBlog] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [tags, setTags] = useState([]);
  const [comments, setComments] = useState([]);
  let [likes, setLikes] = useState([]);
  const [dislikes, setDislikes] = useState([]);
  const [userComment, setUserComment] = useState("");
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [likeClicked, setLikeClicked] = useState(false);

  useEffect(() => {
    const getRecentBlogs = async () => {
      const blogRef = collection(db, "blogs");
      const recentBlogs = query(
        blogRef,
        orderBy("timestamp", "desc"),
        limit(5)
      );
      const docSnapshot = await getDocs(recentBlogs);
      setBlogs(docSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };

    getRecentBlogs();
  }, []);

  useEffect(() => {
    id && getBlogDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return <Spinner />;
  }

  const getBlogDetail = async () => {
    setLoading(true);
    const blogRef = collection(db, "blogs");
    const docRef = doc(db, "blogs", id);
    const blogDetail = await getDoc(docRef);
    const blogs = await getDocs(blogRef);
    let tags = [];
    blogs.docs.map((doc) => tags.push(...doc.get("tags")));
    let uniqueTags = [...new Set(tags)];
    setTags(uniqueTags);
    const blogData = blogDetail.data();
    setBlog(blogData);

    // Update page title with blog title
    if (blogData?.title) {
      document.title = `${blogData.title} - youvaraj.com`;
    }

    const relatedBlogsQuery = query(
      blogRef,
      where("tags", "array-contains-any", blogData.tags, limit(3))
    );
    setComments(blogData.comments ? blogData.comments : []);
    setLikes(blogData.likes ? blogData.likes : []);
    setDislikes(blogData.dislikes ? blogData.dislikes : []);
    const relatedBlogSnapshot = await getDocs(relatedBlogsQuery);
    const relatedBlogs = [];
    relatedBlogSnapshot.forEach((doc) => {
      relatedBlogs.push({ id: doc.id, ...doc.data() });
    });
    setRelatedBlogs(relatedBlogs);
    setActive(null);
    setLoading(false);
  };

  const handleComment = async (e) => {
    e.preventDefault();
    comments.push({
      createdAt: Timestamp.fromDate(new Date()),
      userId,
      name: user?.displayName,
      body: userComment,
    });
    toast.success("Comment posted successfully");
    await updateDoc(doc(db, "blogs", id), {
      ...blog,
      comments,
      timestamp: serverTimestamp(),
    });
    setComments(comments);
    setUserComment("");
  };

  const handleThumbsUp = async () => {
    if (!userId) {
      toast.error("Please login to vote");
      return;
    }

    let newLikes = [...likes];
    let newDislikes = [...dislikes];

    const hasLiked = newLikes.includes(userId);
    const hasDisliked = newDislikes.includes(userId);

    if (hasLiked) {
      // Remove like
      newLikes = newLikes.filter((id) => id !== userId);
      toast.info("Like removed");
    } else {
      // Add like and remove dislike if exists
      newLikes.push(userId);
      if (hasDisliked) {
        newDislikes = newDislikes.filter((id) => id !== userId);
      }
      toast.success("You liked this blog!");
    }

    setLikes(newLikes);
    setDislikes(newDislikes);

    await updateDoc(doc(db, "blogs", id), {
      ...blog,
      likes: newLikes,
      dislikes: newDislikes,
      timestamp: serverTimestamp(),
    });
  };

  const handleThumbsDown = async () => {
    if (!userId) {
      toast.error("Please login to vote");
      return;
    }

    let newLikes = [...likes];
    let newDislikes = [...dislikes];

    const hasLiked = newLikes.includes(userId);
    const hasDisliked = newDislikes.includes(userId);

    if (hasDisliked) {
      // Remove dislike
      newDislikes = newDislikes.filter((id) => id !== userId);
      toast.info("Dislike removed");
    } else {
      // Add dislike and remove like if exists
      newDislikes.push(userId);
      if (hasLiked) {
        newLikes = newLikes.filter((id) => id !== userId);
      }
      toast.success("Feedback recorded");
    }

    setLikes(newLikes);
    setDislikes(newDislikes);

    await updateDoc(doc(db, "blogs", id), {
      ...blog,
      likes: newLikes,
      dislikes: newDislikes,
      timestamp: serverTimestamp(),
    });
  };

  console.log("relatedBlogs", relatedBlogs);
  console.log(`blog details `, blog);
  const imageStyle = {
    width: "800px",
    height: "400px",
    objectFit: "cover",
  };

  const imageAuthor = {
    width: "50px",
    height: "50px",
  };
  return (
    <Container className="my-container">
      <Row>
        <Col sm={8}>
          <div className="containerDetail">
            <div className="containerDetailImgContent">
              <div className="my-image-container">
                <BlogImage
                  src={blog?.imgUrl}
                  alt={blog?.title}
                  className="rounded"
                  style={{ ...imageStyle, width: "100%", maxWidth: imageStyle.width }}
                />
              </div>{" "}
            </div>
          </div>
          <div className="containerDetailBlogTitle"> {blog?.title} </div>
          <div className="containerDetailAuthorInfoSection">
            {/* <div className="containerDetailAuthorInfoImage">
              <Image
                src={blog?.imgUrl}
                roundedCircle
                fluid
                style={imageAuthor}
              />
            </div> */}
            <div className="containerDetailAuthorNameAndDate">
              <div className="containerDetailAuthorName"> {blog?.author} </div>{" "}
              <div className="containerDetailPostDate">
                {getFriendlyDateFormat(blog?.timestamp.toDate().toString())}
              </div>
            </div>
          </div>
          <div
            className="containerDetailBlogContent"
            dangerouslySetInnerHTML={{ __html: blog?.description }}
          />

          <BlogVoting
            handleThumbsUp={handleThumbsUp}
            handleThumbsDown={handleThumbsDown}
            likes={likes}
            dislikes={dislikes}
            userId={userId}
          />
        </Col>
        <Col sm={4}>
          <RelatedBlog id={id} blogs={relatedBlogs} />
        </Col>
      </Row>
    </Container>
  );
};

export default Detail;
